import { type MetaDescriptor } from 'react-router';

import { Duration } from '@boc/duration';
import { generateCacheControlV2 } from '@boc/framework/headers/cache';
import { genHrefLangs } from '@boc/framework';

import { canonicalize, parseParams, urls } from '~/urls';

import { ProductResults } from '~/local/products/search/page';

import { brandInfo } from '#/brand';
import { DEFAULT_CHANNEL, channels } from '#/channels';
import { DEFAULT_LOCALE, supportedLocales } from '#/locales';
import { SEARCH_NOINDEX_THRESHOLD } from '#/seo';

import type { Route } from './+types/search';

export { loader, headers } from '../search/loader';

export const meta: Route.MetaFunction = ({ params, location, data }) => {
  const { channel, locale } = parseParams(params);

  // Products index page canonicalizes to home to reduce keyword cannibalization
  const canonical: MetaDescriptor = {
    tagName: 'link',
    rel: 'canonical',
    href: urls.home(params),
  };

  const hreflangs = genHrefLangs({
    location,
    canonicalize,
    url: urls.products.index,
    channels: Object.values(channels),
    defaultChannel: DEFAULT_CHANNEL,
    defaultLocale: DEFAULT_LOCALE,
    supportedLocales,
  });

  const metaTags = [
    // { name: 'og:image', content: data.product.thumbnail?.url },

    canonical,
    ...hreflangs,

    {
      title: channel.seo?.title
        ? channel.seo.title(`Buy Jigsaw Puzzles and Accessories only at ${brandInfo.name}`)
        : `Buy Jigsaw Puzzles and Accessories only at ${brandInfo.name}`,
    },
    {
      name: 'og:title',
      content: channel.seo?.title
        ? channel.seo.title(`Buy Jigsaw Puzzles and Accessories only at ${brandInfo.name}`)
        : `Buy Jigsaw Puzzles and Accessories only at ${brandInfo.name}`,
    },

    {
      name: 'description',
      content: channel.seo?.description
        ? channel.seo.description(
            `Buy 100, 500, 1000, 2000 pieces and more Jigsaw Pieces only at ${brandInfo.name}. We also have a wide range of accessories to help you display your puzzle once completed. Checkout our range of kids activity books, perfect for kids of all ages.`
          )
        : `Buy 100, 500, 1000, 2000 pieces and more Jigsaw Pieces only at ${brandInfo.name}. We also have a wide range of accessories to help you display your puzzle once completed. Checkout our range of kids activity books, perfect for kids of all ages.`,
    },
    {
      name: 'og:description',
      content: channel.seo?.description
        ? channel.seo.description(
            `Buy 100, 500, 1000, 2000 pieces and more Jigsaw Pieces only at ${brandInfo.name}. We also have a wide range of accessories to help you display your puzzle once completed. Checkout our range of kids activity books, perfect for kids of all ages.`
          )
        : `Buy 100, 500, 1000, 2000 pieces and more Jigsaw Pieces only at ${brandInfo.name}. We also have a wide range of accessories to help you display your puzzle once completed. Checkout our range of kids activity books, perfect for kids of all ages.`,
    },
  ];

  // Add noindex if less than threshold
  if (data?.products && data.products.length < SEARCH_NOINDEX_THRESHOLD) {
    metaTags.push({ name: 'robots', content: 'noindex, follow' });
  }

  return metaTags;
};

export default ProductResults;
